export default __webpack_public_path__ + "static/media/_fruitsap.5e562263.png";